import { apiClient } from './axiosInstance';
import { ensureOk, toFormData } from '../helpers/api-helper';
import { ApiEnvelope } from '@/types/apiEnvelope';
import {
  CoinData,
  MyWalletData,
  DeleteCoinPayload,
  CoinHistoryResponse,
  SendCoinPayload,
  BuyRedCoinPayload,
} from '@/types/wallet';

export const WalletService = {
  async getMyWallet() {
    const { data } = await apiClient.get<ApiEnvelope<MyWalletData>>('/coin/total');
    const result = ensureOk<MyWalletData>(data);
    return result;
  },

  async getGreenCoinsList() {
    const { data } = await apiClient.get<ApiEnvelope<CoinData[]>>('/coin/free');
    const result = ensureOk<CoinData[]>(data);
    return result;
  },

  async getRedCoinsList() {
    const { data } = await apiClient.get<ApiEnvelope<CoinData[]>>('/coin/pay');
    const result = ensureOk<CoinData[]>(data);
    return result;
  },

  async deleteCoins(payload: DeleteCoinPayload) {
    const fd = new FormData();
    payload.type.forEach((t, index) => {
      fd.append('type[]', t);
      fd.append('type_id[]', payload.type_id[index]);
    });
    await apiClient.post<ApiEnvelope>('/coin/delete', fd);
  },

  async getMyWalletRecord() {
    const { data } = await apiClient.get<ApiEnvelope<CoinHistoryResponse>>('/coin/history');
    const result = ensureOk<CoinHistoryResponse>(data);

    return result.data;
  },

  async sendCoins(payload: SendCoinPayload) {
    const fd = new FormData();
    fd.append('receiver', payload.receiver);

    if (payload.tcoin) {
      Object.entries(payload.tcoin).forEach(([storeId, qty]) => {
        fd.append(`tcoin[${storeId}]`, String(qty));
      });
    }

    if (payload.kol_coin) {
      Object.entries(payload.kol_coin).forEach(([kolId, qty]) => {
        fd.append(`kol_coin[${kolId}]`, String(qty));
      });
    }

    if (payload.kol_coin_pay) {
      Object.entries(payload.kol_coin_pay).forEach(([kolId, qty]) => {
        fd.append(`kol_coin_pay[${kolId}]`, String(qty));
      });
    }

    if (payload.womo) {
      Object.entries(payload.womo).forEach(([coinId, qty]) => {
        fd.append(`womo[${coinId}]`, String(qty));
      });
    }

    await apiClient.post<ApiEnvelope>('/coin/send', fd);
    return;
  },

  async buyRedCoins(payload: BuyRedCoinPayload) {
    const fd = toFormData(payload);

    await apiClient.post<ApiEnvelope>('/coin/buy_kol_coin', fd);
    return;
  },
};
